import { render, staticRenderFns } from "./Challenge.vue?vue&type=template&id=59cd82a3&scoped=true&lang=pug&"
import script from "./Challenge.vue?vue&type=script&lang=ts&"
export * from "./Challenge.vue?vue&type=script&lang=ts&"
import style0 from "./Challenge.vue?vue&type=style&index=0&id=59cd82a3&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59cd82a3",
  null
  
)

export default component.exports